import * as React from 'react'
import { useTranslation } from 'react-i18next'

import type { ShipmentTaskFeedItem } from '#/entities/shipment'
import {
  TASK_STATUS,
  TaskStatusButton,
  useUpdateToolbarTask,
} from '#/features/shipment-toolbar'
import { CheckRoundedIcon } from '#/shared/ui/icons'
import { NoteRow } from '#/shared/ui/history-row'

function taskMeta(task: ShipmentTaskFeedItem): React.ReactNode[] {
  const meta: React.ReactNode[] = [task.timestamp]
  if (task.author) meta.push(task.author)
  if (task.date) {
    meta.push(task.startTime ? `${task.date} at ${task.startTime}` : task.date)
  }
  if (task.assignees.length > 0) meta.push(task.assignees.join(', '))
  return meta
}

export function TaskHistoryRow({ task }: { task: ShipmentTaskFeedItem }) {
  const { t } = useTranslation()
  const { updateStatus, isPending, pendingTaskId } = useUpdateToolbarTask()
  const taskPending = isPending && pendingTaskId === task.id
  return (
    <NoteRow
      icon={CheckRoundedIcon}
      titleLeading={
        <TaskStatusButton
          checked
          pending={taskPending}
          disabled={isPending}
          onClick={() => updateStatus(task.id, TASK_STATUS.pending)}
          label={t('quoteDetails.tasks.markAsPending', { title: task.title })}
        />
      }
      title={task.title}
      meta={taskMeta(task)}
    />
  )
}
